import BzbsFinancialHealth from '@/core/FinancialHealth/service/BzbsFinancialHealth.js';

/**
 * Helper for checking Financial Health survey status
 * Can be used across multiple pages
 */
export default {
    /**
     * Check if user has already submitted the survey
     * @param {Object} options - Configuration options
     * @param {Function} options.onNotSubmitted - Callback when user hasn't submitted yet
     * @param {Function} options.onAlreadySubmitted - Callback when user has already submitted
     * @param {Function} options.onError - Callback for other errors
     * @param {Object} options.router - Vue router instance for redirection
     * @param {Boolean} options.redirectOnSubmitted - Whether to redirect to result page if already submitted
     */
    checkSurveyStatus(options = {}) {
        const {
            onNotSubmitted,
            onAlreadySubmitted,
            onError,
            router,
            redirectOnSubmitted = true
        } = options;

        BzbsFinancialHealth.apiCheckSurvey().subscribe({
            next: () => {
                // No error means user hasn't submitted yet
                if (onNotSubmitted) {
                    onNotSubmitted();
                }
            },
            error: (err) => {
                // Error code 1904 means already submitted
                if (err.code === '1904') {
                    if (redirectOnSubmitted && router) {
                        router.replace({ name: 'financial-health-result' });
                    }
                    if (onAlreadySubmitted) {
                        onAlreadySubmitted();
                    }
                } else {
                    if (onError) {
                        onError(err);
                    }
                }
            }
        });
    },

    /**
     * Check if test mode is enabled via query string
     * @param {Object} route - Vue route object
     * @returns {Boolean} - True if test mode is enabled
     */
    isTestMode(route) {
        return route?.query?.test === 'true';
    }
};
